import { useQuery } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../axiosInstance";
import { CancellationRequest } from "../../types/Types";

export function useGetCancellationRequests({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({
    enabled,
    queryKey: ["cancellation-requests"],
    queryFn: async () => {
      const url = getAPIURL("/Admin/Cancellations");
      const res = await axiosInstance<CancellationRequest[]>(url);
      return res.data ?? [];
    },
  });
}
